export const LOADING_QUESTIONS = [
    "Honey never spoils — ancient jars found in tombs were still edible.",
  "Octopuses have three hearts and blue blood.",
  "Bananas are technically berries; strawberries are not.",
  "A cloud can weigh over a million pounds.",
  "Butterflies taste with their feet.",
  "Shuffling a deck of cards almost always results in a combination never seen before.",
  "Cows have best friends and get stressed when separated.",
  "Snails can sleep for up to three years.",
  "Your nose can remember around 50,000 different scents.",
  "The Eiffel Tower grows up to 15 cm taller in summer.",
  "Dolphins call each other by unique names.",
  "Humans share 60% of their DNA with bananas.",
  "Penguins give pebbles as gifts when courting.",
  "Wombats produce cube-shaped poop.",
  "There are more stars in the universe than grains of sand on Earth.",
  "Sneezes can reach speeds of 160 km/h.",
  "A day on Venus is longer than a year on Venus.",
  "Newborn humans have about 300 bones; adults have 206.",
  "Cats cannot taste sweetness.",
  "Koalas sleep up to 22 hours per day.",
  "Sea otters hold hands to avoid drifting apart.",
  "The shortest war in history lasted only 38 minutes.",
  "Some turtles can breathe through their butts.",
  "Sodium metal explodes on contact with water.",
  "A jellyfish species can technically live forever.",
  "Hot water can freeze faster than cold (Mpemba effect).",
  "Sharks existed before trees did.",
  "Your brain is 60% fat.",
  "A 'moment' used to be exactly 90 seconds.",
  "Elephants think humans are cute.",
  "A blue whale's heart is as big as a small car.",
  "Space smells like burnt metal and steak.",
  "Scotland has over 400 words for snow.",
  "You can't hum while holding your nose.",
  "A group of flamingos is called a flamboyance.",
  "The average cloud travels at 30 km/h.",
  "Humans are the only animals that blush.",
  "The Moon moves 3.8 cm away from Earth each year.",
  "The longest English word has 189,819 letters.",
  "Most people walk the equivalent of three Earth laps in a lifetime.",
  "Saturn could float in water.",
  "Eagles can spot prey from 3 km away.",
  "A shrimp's heart is in its head.",
  "There are more plastic flamingos than real flamingos.",
  "Taste buds live for about 10 to 14 days.",
  "Sloths move so slowly that algae grows on them.",
  "The human body emits faint natural light.",
  "Earth days used to be only 18 hours long.",
  "Clouds release millions of liters of water when raining.",
  "Some of the air you breathe contains atoms once exhaled by dinosaurs.",
  "Jellyfish are 95% water.",
  "The first oranges weren't orange — they were green.",
  "Giraffes have the same number of neck bones as humans: seven.",
  "Humans and giraffes have almost identical neck structures.",
  "Avocados are berries; raspberries are not.",
  "Crocodiles can't stick out their tongues.",
  "Koala fingerprints look almost exactly like human ones.",
  "Some frogs can freeze solid and survive.",
  "Bees can recognize human faces.",
  "A group of crows is called a murder.",
  "Goldfish can remember things for months, not seconds.",
  "Octopus arms can act independently of the brain.",
  "Hummingbirds can fly backward.",
  "Tigers have striped skin, not just striped fur.",
  "A day on Mercury lasts 59 Earth days.",
  "Otters have a favorite rock they keep for life.",
  "The human stomach replaces its lining every few days.",
  "A single bolt of lightning is five times hotter than the sun's surface.",
  "Some cats are allergic to humans.",
  "Dogs have a sense of time and can predict routines.",
  "Earthquakes can turn water into jelly-like ground.",
  "Ants don't sleep — they take micro-naps.",
  "Some metals can be liquid at room temperature (like gallium).",
  "Carrots used to be purple.",
  "Trees can communicate through underground fungi networks.",
  "Potatoes were the first vegetable grown in space.",
  "Butterflies remember being caterpillars.",
  "There are more stars in the universe than atoms in your body.",
  "Your brain generates about 20 watts of power.",
  "The human heart beats over 3 billion times in a lifetime.",
  "Lightning strikes Earth around 100 times per second.",
  "Humans have tiny mites living on their faces.",
  "Octopuses can taste with their skin.",
  "The Amazon rainforest produces 20% of the world's oxygen.",
  "Peanuts aren't nuts — they're legumes.",
  "A jellyfish has no brain, heart, or bones.",
  "Humans are the only species that cook food.",
  "A full NASA spacesuit costs about $12 million.",
  "The Great Wall of China is not visible from space with the naked eye.",
  "A chameleon's tongue can be twice the length of its body.",
  "Birds are dinosaurs' closest living relatives.",
  "A horse's teeth take up more space in its head than its brain.",
  "Ostriches can run faster than horses.",
  "Mosquitoes prefer people who just ate bananas.",
  "A single teaspoon of soil contains more organisms than people on Earth.",
  "Starfish have no brain and no blood.",
  "Some ants explode as a defense mechanism.",
  "Humans glow more brightly at night (biochemically).",
  "The coldest temperature ever recorded on Earth was -89.2°C.",
  "A bolt of lightning contains enough energy to toast 100,000 slices of bread.",
  "Horses can sleep both standing up and lying down.",
  "Orcas are actually dolphins, not whales.",
  "A day on Mars is only 37 minutes longer than a day on Earth.",
  "Antarctica is the driest, windiest, and coldest continent.",
  "Tomatoes were once believed to be poisonous in Europe.",
  "On Jupiter and Saturn, it literally rains diamonds.",
  "Bamboo can grow up to 1 meter per day.",
  "The human nose can detect over 1 trillion scents.",
  "Crows can hold grudges for years.",
  "Your body has enough iron to make a tiny nail.",
  "The giant squid has the largest eyes in the animal kingdom.",
  "Spiders can't fly, but some use silk to ride the wind—ballooning.",
  "The longest recorded flight of a chicken is 13 seconds.",
  "Hiccups start in the diaphragm, not the throat.",
  "A hummingbird's heart can beat more than 1,200 times per minute.",
  "The fingerprints of a koala are nearly indistinguishable from humans.",
  "Humans are the only species with chins.",
  "Sharks can live for over 400 years.",
  "Apples float in water because they're 25% air.",
  "Squirrels forget where they bury most of their nuts.",
  "You're taller in the morning than at night.",
  "A bee's wings beat 200 times per second.",
  "Turtles can live for over 150 years.",
  "A crocodile cannot move its tongue.",
  "Owls can't move their eyes, so they rotate their heads instead.",
  "A flea can jump 200 times its body length.",
  "Earth is the only planet not named after a god.",
  "Caterpillars have more muscles than humans.",
  "Rats laugh when tickled.",
  "The average person has 10,000 taste buds.",
  "A jellyfish is 95% water and 5% “what even is that biology?”",
  "Humans and dolphins are the only animals known to have sex for pleasure.",
  "Your body contains about 0.2 mg of gold.",
  "Camels have three eyelids to protect against sand.",
  "Pineapples take nearly two years to grow.",
  "Octopuses can unscrew jars from the inside.",
  "A cheetah can accelerate faster than a Ferrari.",
  "Gorillas can catch human colds.",
  "A whale's tongue can weigh as much as an elephant.",
  "The deepest place on Earth is nearly 11 km down.",
  "Sea sponges are technically animals.",
  "Ravens can mimic human speech better than parrots.",
  "A day on Pluto lasts 153 hours.",
  "Blue eyes are actually colorless—they reflect light like water.",
  "Rabbits can see behind them without turning their heads.",
  "Fireflies aren't flies—they're beetles.",
  "Humans share 98.8% of DNA with chimpanzees.",
  "The world's largest desert is Antarctica.",
  "The oldest known animal lived 507 years (a clam).",
  "The biggest flower on Earth smells like rotten meat.",
  "A polar bear's fur isn't white—it's actually transparent.",
  "Crabs communicate by waving their claws and drumming.",
  "A tiger's roar can be heard 3 km away.",
  "Pluto has mountains made of ice.",
  "Some frogs completely freeze and thaw back to life.",
  "Hippos produce a natural sunscreen that is red-colored.",
  "The largest living structure on Earth is the Great Barrier Reef.",
  "Some fish can climb waterfalls.",
  "A moth has no stomach.",
  "A chameleon can move its eyes independently.",
  "The sun loses 4 million tons of mass every second.",
  "The average human produces 25,000 quarts of saliva in a lifetime.",
  "A group of jellyfish is called a smack.",
  "Earth has more trees today than it did 100 years ago.",
  "A mantis shrimp can punch with the force of a bullet.",
  "There are more galaxies in the universe than people on Earth.",
  "The largest snowflake ever recorded was 38 cm wide.",
  "Dragonflies have near-360-degree vision.",
  "Sharks don't get cavities—they have fluoride in their teeth.",
  "Koalas have smooth brains, which is why they're not the brightest animals.",
  "The hottest temperature ever recorded on Earth was 56.7°C.",
  "Red pandas use their tails for balance and warmth.",
  "The Earth's core is as hot as the surface of the sun.",
  "Spiders can regrow lost legs.",
  "The average cloud has the same weight as 100 elephants.",
  "Horses can't burp.",
  "Some lizards shoot blood from their eyes as defense.",
  "Jellyfish existed before dinosaurs.",
  "A blue whale's tongue can weigh 3 tons.",
  "The shortest commercial flight lasts 57 seconds.",
  "Termites never sleep.",
  "Raccoons wash their food instinctively—even fake food.",
  "A group of porcupines is called a prickle.",
  "Some fish can breathe air.",
  "You can hear a blue whale's heartbeat from 3 km away.",
  "The Earth wobbles like a spinning top.",
  "A full head of human hair can support up to 12 tons.",
  "Oysters can change sex multiple times.",
  "Some ants farm aphids like cattle.",
  "The coldest place in the universe is a lab on Earth.",
  "Cows produce more milk when listening to relaxing music.",
  "The galaxies we see are only 5% of the universe.",
  "One strand of DNA is two meters long.",
  "Jellyfish don't age—they just reset.",
  "Birds don't urinate.",
  "Your brain can store 2.5 petabytes of data.",
  "The fastest wind ever recorded was 408 km/h.",
  "There are more chickens on Earth than humans.",
  "The deepest part of the ocean is deeper than Mount Everest is tall.",
  "A hummingbird weighs less than a coin.",
  "The oldest living tree is over 4,800 years old.",
  "The Milky Way is moving through space at 2.1 million km/h.",
  "A shark can detect one drop of blood in 25 gallons of water.",
  "The average lightning bolt is 5 km long.",
  "Pluto has five moons.",
  "Some fish communicate by passing gas.",
  "The world's smallest reptile is the size of a sunflower seed.",
  "Frogs absorb water through their skin instead of drinking.",
  "A comet's tail can stretch millions of kilometers.",
  "Elephants can recognize themselves in a mirror.",
  "A bee can visit 5,000 flowers in a single day.",
  "The largest volcano in the solar system is on Mars.",
  "Humans and octopuses share a distant common ancestor.",
  "Your brain uses about 20% of your body's energy.",
  "Seahorses mate for life and hold tails while swimming.",
  "A full moon is actually 14% brighter during certain times of the year.",
  "Many insects can see ultraviolet light.",
  "The average human spends 6 months of their life waiting at red lights.",
  "The Earth rotates at about 1,600 km/h.",
  "Some sea cucumbers can liquefy their bodies to escape predators.",
  "The world's largest shark was longer than a school bus.",
  "Sponges can filter thousands of liters of water per day.",
  "The human eye can distinguish 10 million different colors.",
  "Your hair grows faster in warm weather.",
  "A dragonfly can fly 60 km/h.",
  "Jupiter has a storm that has lasted for over 300 years.",
  "Humans shed about 600,000 particles of skin every hour.",
  "There are more stars in the universe than atoms in your body.",
  "The tongue is the fastest healing muscle in the human body.",
  "Black holes can slow down time.",
  "A rainbow is actually a full circle — we only see half from the ground.",
  "Antarctica contains 70% of Earth's freshwater.",
  "The average hummingbird beats its wings 70 times per second.",
  "A sneeze can travel 8 meters.",
  "Rabbits can see almost 360 degrees around them.",
  "The Earth's inner core is solid metal.",
  "Camels store fat, not water, in their humps.",
  "The world's longest cave system is over 640 km long.",
  "Beetles make up 25% of all animal species.",
  "The smallest mammal is the size of a bumblebee.",
  "Some turtles can live for weeks without oxygen.",
  "Humans have explored less than 5% of the ocean.",
  "The Great Barrier Reef is visible from space.",
  "Sloths take two weeks to digest a meal.",
  "Birds can sleep while flying.",
  "Stars do not twinkle in space — only from Earth.",
  "A crocodile's bite is 3,700 pounds of pressure.",
  "Saturn has at least 146 moons.",
  "A raindrop falls at about 20 km/h.",
  "The largest known star is 1,700 times wider than our sun.",
  "Your heartbeat syncs to the rhythm of music you listen to.",
  "Bats are the only mammals capable of sustained flight.",
  "A teaspoon of honey represents the life work of 12 bees.",
  "The world's oldest ocean water is 1.5 billion years old.",
  "Grasshoppers have ears on their stomachs.",
  "Earth's magnetic poles move around 40 km per year.",
  "Butterflies can see colors we can't even imagine.",
  "Some crabs can climb trees.",
  "Alaska is the westernmost, easternmost, and northernmost U.S. state.",
  "The fastest bird dives at 380 km/h.",
  "Mars has the largest canyon in the solar system.",
  "Human bones are stronger than concrete.",
  "A lobster's teeth are in its stomach.",
  "Most of the universe is made of dark matter and dark energy.",
  "Starfish can regenerate entire arms.",
  "The Amazon rainforest covers 40% of South America.",
  "A baby spider is called a spiderling.",
  "The oldest known star is almost as old as the universe.",
  "A jellyfish has existed on Earth for 500 million years.",
  "Some caterpillars disguise themselves as snake heads.",
  "A zebra's stripes are as unique as fingerprints.",
  "The world's largest frog weighs as much as a housecat.",
  "The human liver can regrow itself.",
  "A python can go months without eating.",
  "Rainbows can appear at night — called moonbows.",
  "Ants can lift up to 50 times their own weight.",
  "Dolphins sleep with half their brain at a time.",
  "Whales have belly buttons.",
  "Spiders can fly using Earth's electric fields.",
  "A day on Earth is getting longer due to the Moon slowing rotation.",
  "Some birds rehearse their songs in their sleep.",
  "A shrimp's heartbeat can be seen through its body.",
  "A blue whale's veins are big enough for a child to crawl through.",
  "There's a planet made entirely of diamonds.",
  "Earth once had two moons.",
  "Male penguins take care of the egg while the female hunts.",
  "Snowflakes can have up to 200 branches.",
  "The hottest chili pepper is strong enough to cause hallucinations.",
  "A gecko can stick to glass using millions of tiny hairs.",
  "Venus spins in the opposite direction of Earth.",
  "Your taste buds are replaced every two weeks.",
  "Sharks don't have bones — only cartilage.",
  "Some lizards can run across water.",
  "A pangolin is the world's most trafficked animal.",
  "The Sahara Desert was once covered in lakes and forests.",
  "The Moon has moonquakes.",
  "A cockroach can live a week without its head.",
  "Only female mosquitoes bite.",
  "A fossil of a giant penguin was found — over 2 meters tall.",
  "The Mariana Trench is home to glowing creatures.",
  "Humans are bioluminescent, but too dim to see.",
  "Bees can fly higher than Mount Everest.",
  "Ravens hold funerals for their dead.",
  "Jellyfish don't have brains or hearts.",
  "Some mushrooms glow in the dark.",
  "A pigeon once won a medal for saving soldiers' lives.",
  "A cloud can store millions of liters of water.",
  "There's a species of fish that can walk on land.",
  "Most diamonds are older than the stars in the sky.",
  "Some butterflies drink blood.",
  "The human body contains enough carbon to make 9,000 pencils.",
  "A snail has thousands of tiny teeth on its tongue.",
  "Horseshoes were invented thousands of years ago.",
  "Saturn's rings are mostly ice.",
  "A mantis shrimp can see 16 types of color receptors.",
  "Mount Everest grows by about 4 mm per year.",
  "Whale sharks have 3,000 tiny teeth.",
  "The Earth's oceans contain 20 million tons of gold.",
  "Some ants can survive in space.",
  "Flamingos are only pink because of their diet.",
  "There are more stars than grains of sand on all beaches combined.",
  "Sharks have been around for 450 million years.",
  "The largest turtle species can weigh over 900 kg.",
  "Certain frogs grow hair-like structures during mating season.",
  "Rattlesnakes can smell with their tongues.",
  "The Moon is slowly causing Earth's rotation to slow.",
  "Rain has a smell — it's called petrichor.",
  "The human stomach regenerates every 3–4 days.",
  "Sea stars have no blood — they use seawater instead.",
  "Penguins can drink seawater.",
  "Some spiders can live underwater for hours.",
  "The Sun makes up 99.8% of the solar system's mass.",
  "A single coral can live hundreds of years.",
  "Giraffes have the highest blood pressure in the animal kingdom.",
  "A tiger's stripes are unique to each tiger.",
  "Bumblebees can sense Earth's electric field.",
  "Certain parrots can live over 80 years.",
  "The largest animal migration happens underwater — daily.",
  "Dust storms on Mars can cover the entire planet.",
  "Humans produce enough saliva annually to fill two bathtubs.",
  "Some birds use tools to get food.",
  "There are more trees on Earth than stars in the Milky Way.",
  "Snakes can sense earthquakes days before they happen.",
  "The Amazon River once flowed in the opposite direction.",
  "Gorillas burp to communicate.",
  "A group of rhinos is called a crash.",
  "The Moon smells like gunpowder to astronauts.",
  "The fastest human-made object travels at 692,000 km/h.",
  "Owls can rotate their heads 270 degrees.",
  "The world's largest iceberg was bigger than Jamaica.",
  "Cheetahs can't roar — they meow.",
  "Bees can see electric fields around flowers.",
  "Raindrops are not tear-shaped — they're more like hamburger buns.",
  "The Pacific Ocean is shrinking by 1 inch per year.",
  "Orcas drown sharks by flipping them upside down.",
  "Spiders recycle their own webs by eating them.",
  "The human heart can beat outside the body during surgery.",
  "Plants can communicate through chemical signals.",
  "There are lakes on Titan, Saturn's moon — made of methane.",
  "Goldfish can see infrared and ultraviolet light.",
  "Antarctica has over 300 lakes under the ice.",
  "Some whales sing complex songs that travel hundreds of kilometers.",
  "A full-grown oak tree can drink 190 liters of water per day.",
  "Stars are born in massive clouds called nebulae.",
  "The average raindrop falls for only 2 minutes before hitting the ground.",
  "A comet's tail always points away from the sun.",
  "Penguins have a gland that filters salt from seawater.",
  "Some sea snakes can breathe through their skin.",
  "There are more microplastics in the ocean than there are stars in the Milky Way.",
  "The Earth's rotation is slowing by 2 milliseconds every century.",
  "Some insects have ears on their knees.",
  "Sea turtles can detect Earth's magnetic field.",
  "The average adult has 5 liters of blood.",
  "There's a species of jellyfish the size of a grain of sand.",
  "Some starfish species have up to 40 arms.",
  "The hottest planet in the solar system is Venus, not Mercury.",
  "Birds navigate using the stars.",
  "The Great Wall of China is over 21,000 km long.",
  "Trees release chemicals when they're being eaten to warn others.",
  "Stars twinkle because of Earth's atmosphere.",
  "A cubic meter of lead weighs around 11 tons.",
  "Sea otters have the densest fur of any animal.",
  "A whale can hold its breath for 2 hours.",
  "The Earth's crust is thinner than an apple's skin by ratio.",
  "A lightning bolt is five times hotter than the sun's surface.",
  "Some animals can sense magnetic fields.",
  "Purple used to be the most expensive color to make.",
  "Hummingbirds remember every flower they've visited.",
  "The Amazon rainforest makes 20% of the world's oxygen.",
  "Some spiders dance to attract mates.",
  "Human blood is red because of iron; octopus blood is blue because of copper.",
  "The largest dinosaur bone ever found weighs over 500 kg.",
  "Sharks can enter a trance-like state when flipped upside down.",
  "Earth once had a supercontinent called Pangaea.",
  "Crabs can grow new claws if they lose them.",
  "Lions can sleep up to 20 hours a day.",
  "The universe is expanding faster than the speed of light.",
  "The Sun will eventually become a white dwarf.",
  "Jellyfish can clone themselves.",
  "The center of our galaxy smells like raspberries and rum (chemically speaking).",
  "Some deserts receive less than 1 cm of rainfall per year.",
  "A snowflake's shape depends on air humidity and temperature.",
  "The Moon once had active volcanoes.",
  "A newborn kangaroo is the size of a jellybean.",
  "Some lizards can detach their tails to escape danger.",
  "Ants have super-efficient communication systems.",
  "Elephants mourn their dead.",
  "Birds evolved from dinosaurs.",
  "Neptune has the fastest winds in the solar system.",
  "Some snakes give birth to live young, others to eggs.",
  "Clownfish are all born male and can change sex.",
  "Trees can live for thousands of years.",
  "The Sun accounts for 99.86% of all mass in the solar system.",
  "The Earth's oceans cover 71% of the surface.",
  "Some insects can survive being frozen and thawed.",
  "The Milky Way contains over 100 billion planets.",
  "A blue whale can eat up to 4 tons of krill in a day.",
  "Owls are nearly silent flyers.",
  "The smallest bone in the human body is in the ear.",
  "Human teeth are as strong as shark teeth.",
  "The tallest waterfall is underwater in the Denmark Strait.",
  "Some birds can recognize human faces.",
  "A camel can drink 100 liters of water in 10 minutes.",
  "Sponges are among the simplest multicellular animals.",
  "The Earth's magnetic field protects us from solar radiation.",
  "Mars has frozen water at its poles."
];